import { AxiosInstance } from 'axios';

import { IFormData } from 'src/views/LinkCreate/types';
import { insertId } from '../insertId';

const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }

  return response.result;
};

export default (api: AxiosInstance, url: string) => async (
  parameterId: number,
  data: IFormData
) => {
  const urlWithId = insertId(url, parameterId);
  const response = await api.post(urlWithId, data);
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/link/addItem.ts